export let data = [
  {
    name: "Pastry - Chocolate Chip Muffin",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "5",
  },
  {
    name: "Beef - Rib Roast, Cap On",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "3",
  },
  {
    name: "Truffle Cups - White Paper",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "4",
  },
  {
    name: "Wine - Zinfandel California 2002",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "7",
  },
  {
    name: "Mcguinness - Blue Curacao",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "9",
  },
  {
    name: "Artichoke - Hearts, Canned",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "7",
  },
  {
    name: "Cookies Oatmeal Raisin",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "4",
  },
  {
    name: "Lemon Grass",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "4",
  },
  {
    name: "Olive - Spread Tapenade",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "4",
  },
  {
    name: "Chips - Doritos",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "1",
  },
  {
    name: "Leeks - Baby, White",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "1",
  },
  {
    name: "Pork - Smoked Kassler",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "7",
  },
];
let x = [
  {
    name: "Tomato - Green",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "0",
  },
  {
    name: "Ham - Proscuitto",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "8",
  },
  {
    name: "Bag Clear 10 Lb",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "6",
  },
  {
    name: "Salt - Rock, Course",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "6",
  },
  {
    name: "Fenngreek Seed",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "1",
  },
  {
    name: "Tea - Decaf Lipton",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "8",
  },
  {
    name: "Kiwano",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "1",
  },
  {
    name: "Cod - Fillets",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "5",
  },
  {
    name: "Squid Ink",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "3",
  },
  {
    name: "Artichoke - Hearts, Canned",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "7",
  },
  {
    name: "Veal - Slab Bacon",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "5",
  },
  {
    name: "Chilli Paste, Sambal Oelek",
    image_url: "http://dummyimage.com/100x100.png/cc0000/ffffff",
    price: "1",
  },
  {
    name: "Cherries - Frozen",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "2",
  },
  {
    name: "Parsley - Fresh",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "9",
  },
  {
    name: "Cranberries - Dry",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "6",
  },
  {
    name: "Compound - Passion Fruit",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "1",
  },
  {
    name: "Tumeric",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "7",
  },
  {
    name: "Cream - 35%",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "3",
  },
  {
    name: "Onion Powder",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "2",
  },
  {
    name: "Octopus",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "9",
  },
  {
    name: "Tart Shells - Sweet, 2",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "0",
  },
  {
    name: "Sauce - Plum",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "7",
  },
  {
    name: "Flour Dark Rye",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "4",
  },
  {
    name: "Miso - Soy Bean Paste",
    image_url: "http://dummyimage.com/100x100.png/ff4444/ffffff",
    price: "0",
  },
  {
    name: "Rosemary - Fresh",
    image_url: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
    price: "3",
  },
  {
    name: "Pork - Suckling Pig",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "6",
  },
  {
    name: "Lamb Rack - Ontario",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "7",
  },
  {
    name: "Stock - Chicken, White",
    image_url: "http://dummyimage.com/100x100.png/dddddd/000000",
    price: "0",
  },
];
